
import React from 'react'
import { Link } from 'react-router-dom'

function Termsconditions(props) {
  return (
    <div>
        


        {/* Start Breadcrumb area  */}
      <div className="index-one">
          <main>
           <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="breadcrumb-inner text-center">
                    <h1 className="title split-collab">Terms & Conditions</h1>
                    <ul className="page-list">
                    <li className="tmp-breadcrumb-item">
                        <a href="/">Home</a>
                    </li>
                    <li className="icon">
                        <i className="fa-solid fa-angle-right" />
                    </li>
                    <li className="tmp-breadcrumb-item active">
                    Terms & Conditions</li>
                    </ul>
                    <div className="circle-1" />
                </div>
                </div>
            </div>
            </div>
        </div>
            <section className="privacy-policy-section tmp-section-gap">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="inner">
          <div className="section-head text-align-left">
            <h2 className="section-title">Terms & Conditions</h2>
          </div>

          <p className="description">
            Welcome to Vaishnav To Vaishnav Business Organization (v2vbn.org). By accessing or using our website, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
          </p>

          <div className="policy-section">
            <h3 className="title">Use of Website</h3>
            <p className="description">
              You agree to use this website only for lawful purposes and in a manner that does not infringe the rights or restrict the use of this site by any third party.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Account and Registration</h3>
            <p className="description">
              You may be required to register and provide information about yourself. You agree that any information you provide will always be accurate and up to date.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Pricing and Payments</h3>
            <p className="description">
              All prices listed on the site are in Indian Rupees (INR). We reserve the right to change prices or services without prior notice. Payments must be made through approved payment gateways.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Intellectual Property</h3>
            <p className="description">
              All content, trademarks, and data on this site, including software, text, images, and graphics, are the property of v2vbn.org or its licensors and are protected by copyright and intellectual property laws.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Limitation of Liability</h3>
            <p className="description">
              v2vbn.org shall not be liable for any indirect, incidental, or consequential damages resulting from the use or the inability to use the website or its services.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Termination of Use</h3>
            <p className="description">
              We reserve the right to terminate or suspend access to the website for users who violate these terms or engage in unlawful activities.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Governing Law</h3>
            <p className="description">
              These Terms shall be governed and construed in accordance with the laws of India. Any disputes shall be subject to the jurisdiction of the courts in Gujarat, India.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Modifications</h3>
            <p className="description">
              We reserve the right to update or change these Terms at any time. Continued use of the website after changes indicates your acceptance of the revised terms.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Contact Us</h3>
            <p className="description">
              If you have any questions or concerns regarding these Terms and Conditions, please contact us at:
            </p>
            <ul className="policy-list">
              <li>📧 Email: <Link to="mailto:admin@v2vbn.org" style={{ color: "#333" }}>admin@v2vbn.org</Link></li>
              <li>🌐 Website: <Link to="/" style={{ color: "#333" }}>https://v2vbn.org</Link></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>

          </main>
        </div>
        {/* End Breadcrumb area  */}


    </div>
  )
}

export default Termsconditions